import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Form, Button, Container, Alert, Row, Col } from 'react-bootstrap'
import { formatErrorResponse } from '../utils/errorHandlers'
import { warehouseAPI } from '../api/warehouseAPI';
import { usePermissions } from '../contexts/PermissionContext'

function CreateWarehouseScreen() {
    const { hasPermission, loading: permissionsLoading } = usePermissions()
    const navigate = useNavigate()
    const [warehouse, setWarehouse] = useState({
        name: '',
        address: ''
    })
    const [error, setError] = useState(null)

    const submitHandler = async (e) => {
        e.preventDefault()
        try {
            await warehouseAPI.create(warehouse)
            navigate('/warehouses')
        } catch (error) {
            setError(formatErrorResponse(error))
        }
    }

    if (permissionsLoading) {
        return (
            <Container className="py-3">
                <div className="text-center">Loading...</div>
            </Container>
        )
    }

    if (!hasPermission('locations.modify')) {
        return (
            <Container className="py-3">
                <Alert variant="danger">
                    You don&apos;t have permission to create warehouses.
                </Alert>
            </Container>
        )
    }

    return (
        <Container>
            <Row className="justify-content-left">
                <Col md={8} lg={6}>
                    <h1>Create Warehouse</h1>
                    <Form onSubmit={submitHandler}>
                        <Form.Group className="mb-4" controlId="name">
                            <Form.Label>Name*</Form.Label>
                            <Form.Control
                                type="text"
                                value={warehouse.name}
                                onChange={(e) => setWarehouse({...warehouse, name: e.target.value})}
                                required
                                placeholder="Enter name"
                                autoComplete="off"
                                spellCheck="false"
                            />
                        </Form.Group>

                        <Form.Group className="mb-4" controlId="location">
                            <Form.Label>Address</Form.Label>
                            <Form.Control
                                type="text"
                                value={warehouse.address}
                                onChange={(e) => setWarehouse({...warehouse, address: e.target.value})}
                                placeholder="Enter address"
                                autoComplete="off"
                                spellCheck="false"
                            />
                        </Form.Group>
                        {error && (
                            <Alert variant="danger" onClose={() => setError(null)} dismissible>
                                {error}
                            </Alert>
                        )}
                        <Button variant="success" type="submit" className="me-2">
                            Create
                        </Button>
                        <Button 
                            variant="outline-primary" 
                            onClick={() => navigate('/warehouses')}
                        >
                            <i className="fas fa-arrow-left me-2"></i>
                            Back to List
                        </Button>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}

export default CreateWarehouseScreen 